import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_MEDIA_GATEWAY,
  MediaGateway,
} from './mediaGateway.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getMediaGatewayList(
): AxiosPromise<ServerResponse<MediaGateway>> {
  return http.get(`${API_PATH_MEDIA_GATEWAY}`);
}

export function getMediaGateway(
  id: string,
): AxiosPromise<ServerResponse<MediaGateway>> {
  return http.get(`${API_PATH_MEDIA_GATEWAY}/${id}`);
}

export function createMediaGateway(
  body: WithAuditDetails<MediaGateway>,
): AxiosPromise<ServerResponse<MediaGateway>> {
  return http.post(`${API_PATH_MEDIA_GATEWAY}`, body);
}

export function updateMediaGateway(
  id: string,
  body: WithAuditDetails<MediaGateway>,
): AxiosPromise<ServerResponse<MediaGateway>> {
  return http.put(`${API_PATH_MEDIA_GATEWAY}/${id}`, body);
}

export function deleteMediaGateway(
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<MediaGateway>> {
  return http.delete(`${API_PATH_MEDIA_GATEWAY}/${id}`, { data: body.auditDetails });
}
